import { useEffect, useRef, useState } from "react";
import { itx } from "../translationItx/itx";
import SettingsScreen from "../SettingsScreen";
import BaseDialog from "./BaseDialog";
import Settings from "../models/Settings";
import { copyProperties } from "../models/utils";
import { stopDebugTextTranslation } from "../translationItx/debugTextTranslation";
import { updateUserDetails } from "../components/account/Login/Login";

export default function SettingsDialog(props: { defaultPane?: string }): JSX.Element {
  const [oldSettings, setOldSettings] = useState<Settings>();

  useEffect(() => {
    const xOldSetting = new Settings();
    copyProperties(state.settings, xOldSetting);
    xOldSetting.uiLanguage = state.settings.uiLanguage;
    setOldSettings(xOldSetting);
  }, []);

  async function leavePaneHandler(wasSaved: boolean) {
    // "wasSaved" indicates wheather the pane was just closed or the save button was clicked.

    if (wasSaved) {
      await state.settings.setUiLanguage(state.settings.uiLanguage);
      if (!state.settings.debugTranslation) {
        stopDebugTextTranslation();
      }
      // set here company name, etc.

      let changedValues: any = {};

      // if (state.settings.userName != state.loggedInUser.userName) {
      //   changedValues = { name: state.settings.userName, ...changedValues };
      // }
      if (state.settings.companyName != state.loggedInUser.companyName) {
        changedValues = {
          company_name: state.settings.companyName,
          ...changedValues,
        };
      }
      updateUserDetails(changedValues);

      //copyProperties(newSettings, state.settings);
      state.settings.raiseOnChange();
    } else {
      copyProperties(oldSettings, state.settings);
      if (oldSettings) await state.settings.setUiLanguage(oldSettings.uiLanguage);
      state.settings.raiseOnChange();
      // state.settings.fromJSON(oldSettings.current);
    }
    // state.navigate("/app");
  }
  return (
    <BaseDialog
      title={itx("SettingsScreen.settings", "Einstellungen ")}
      onOk={() => {
        leavePaneHandler(true);
        return true;
      }}
      onAbort={() => {
        leavePaneHandler(false);
        return true;
      }}
    >
      <SettingsScreen defaultPane={props.defaultPane} />
    </BaseDialog>
  );
}
